__webpack_require__.p = "/my-hex-2048-game/";